import { Module } from 'vuex';
import { RootState } from '@/store/types';
import { CoursesState } from '@/store/courses/types';
import actions from './actions';

const Courses: Module<CoursesState, RootState> = {
  actions,
};

export default Courses;
